/**
 * --------------------------------------------------------------------------
 * Basic Modules: ProductSlider.js
 * --------------------------------------------------------------------------
 */

import Util from "./Util";

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const DEBUG         = false;
const NAME          = 'productSlider';
const DATA_KEY      = 'productSlider';
const EVENT_KEY     = `.${DATA_KEY}`;
const LOG_KEY       = `[${NAME}]`;

const Default = {
};

const Event   = {
    RESIZE          :  `resize${EVENT_KEY}`,
};

const ClassName = {
};

const Selector = {
    TOGGLE          : '.js-product-slider-for',
    NAV_CONTAINER   : '.js-product-slider-nav',
};

const DataAttr = {};

/**
 * @see https://codepen.io/Corpus/pen/dqJEKY (slick slider + magnific popup)
 * @see https://codepen.io/denmch/pen/RMbVbj (detail view)
 *
 * @type {constructor}
 */
class ProductSlider {

    /**
     * Constructor.
     *
     * @param element
     * @param config
     */
    constructor(element, config)
    {
        DEBUG && console.log(LOG_KEY, 'init');

        this.resizeTimeout = null;

        this._element   = element;
        this._nav       = document.querySelector(Selector.NAV_CONTAINER);
        this._config    = this._getConfig(config);

        //this._addEventListeners();
        this._setup();
    }


    destroy() {
        this.$el.off('.' + name);
        this.$el.find('*').off('.' + name);

        this.$el.removeData(name);
        this.$el = null;
    }

    // Private

    _getConfig(config) {
        return {
            ...Default,
            ...config
        };
    }

    _isMobile() {
        return (Util.viewport === 'mobile' || Util.viewport === 'phablet');
    }

    _addEventListeners() {
        $(window).on(Event.RESIZE, (event) => this._handleWindowResize(event));
    }

    _setup() {

        let $carousel = $(this._element);

        $carousel
            .slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                adaptiveHeight: false,
                asNavFor: Selector.NAV_CONTAINER
            })
            .magnificPopup({
                type: 'image',
                delegate: 'a:not(.slick-cloned)',
                closeOnContentClick: false,
                tLoading: 'Loading...',
                mainClass: 'mfp-zoom-in mfp-img-mobile',
                image: {
                    verticalFit: true,
                    tError: '<a href="%url%">Photo #%cur% not loaded</a>'
                },
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    tCounter: '<span class="mfp-counter">%curr% of %total%</span>',
                    preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
                },
                zoom: {
                    enabled: true,
                    duration: 300
                },
                removalDelay: 300, //delay removal by X to allow out-animation
                callbacks: {
                    open: function() {
                        // overwrite default prev + next function. Add timeout for css3 crossfade animation
                        $.magnificPopup.instance.next = function() {
                            this.wrap.removeClass('mfp-image-loaded');
                            setTimeout(() => {
                                $.magnificPopup.proto.next.call(this);
                            }, 120);
                        };
                        $.magnificPopup.instance.prev = function() {
                            this.wrap.removeClass('mfp-image-loaded');
                            setTimeout(() => {
                                $.magnificPopup.proto.prev.call(this);
                            }, 120);
                        };

                        let current = $carousel.slick('slickCurrentSlide');
                        $carousel.magnificPopup('goTo', current);
                    },
                    imageLoadComplete: function() {
                        setTimeout(() => {
                            this.wrap.addClass('mfp-image-loaded');
                        }, 16)
                    },
                    beforeClose: function() {
                        $carousel.slick('slickGoTo', parseInt(this.index));
                    }
                }
            })
        ;

        if (this._nav) {
            $(this._nav).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                asNavFor: Selector.TOGGLE,
                dots: false,
                arrows: true,
                centerMode: false,
                focusOnSelect: true,
                variableWidth: true,
            });
        }
    }

    /**
     * Handle the resizing of the window
     */
    _handleWindowResize() {

        if (this.resizeTimeout) return;

        this._setup();

        this.resizeTimeout = setTimeout(() => {
            this.resizeTimeout = null;
        }, 500);
    }

    // Static

    /**
     * Convenient static method to initiate the module.
     *
     * @param config
     * @param selector
     */
    static bind (config, selector) {
        ProductSlider._jQueryInterface.call($(selector || Selector.TOGGLE), config);
    }

    /**
     * jQuery Interface
     * @param config
     * @returns {*}
     */
    static _jQueryInterface(config) {
        return this.each(function() {
            const $this = $(this);
            let data    = $this.data(DATA_KEY);
            let _config = {
                ...Default,
                ...$this.data(),
                ...typeof config === 'object' && config ? config : {}
            };

            if (!data) {
                data = new ProductSlider(this, _config);
                $this.data(DATA_KEY, data);
            }

            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') {
                    throw new TypeError(`No method named "${config}"`);
                }
                data[config]();
            }
        });
    }
}

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn[NAME] = ProductSlider._jQueryInterface;
$.fn[NAME].Constructor = ProductSlider;


export default ProductSlider;
